import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { UPDATE_BLOCK_DATE, UPDATE_BLOCK_DATE_SUCCESS, UPDATE_BLOCK_DATE_ERROR } from '../../actions';
import apiCall from '../../../apiCall';
import cogoToast from 'cogo-toast';

function* updateBlockDate({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v1/golf-inventory/block-date/update`,
      method: 'PUT',
      data: payload?.data,
      headers: {
        ...filteredHeaders,
      },
    });

    if (response.status === 200) {
      cogoToast.success(`${response?.data?.message}`);
      yield put({
        type: UPDATE_BLOCK_DATE_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({
        type: UPDATE_BLOCK_DATE_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: UPDATE_BLOCK_DATE_ERROR, payload: error });
  }
}

export function* watchupdateBlockDate() {
  yield takeEvery(UPDATE_BLOCK_DATE, updateBlockDate);
}

function* updateBlockDateSaga() {
  yield all([fork(watchupdateBlockDate)]);
}

export default updateBlockDateSaga;
